import HTTP from '../common/http-common';

const END_POINT = '/company';

const listCompany = () => HTTP.get(END_POINT, { cache: false });
const isExistCompanyCode = (companyCode, companyId) => HTTP.get(END_POINT +  "/companycode/" + companyCode + "/" + companyId, { cache: false });
const insert = (data) => HTTP.post(END_POINT, {
    companyCode: data.companyCode,
    companyName: data.companyName,
    taxId: data.taxId,
    address: data.address,
    tel: data.tel,
    fax: data.fax
});
const update = (data) => HTTP.post(END_POINT + "/" + data.companyId, {
    companyCode: data.companyCode,
    companyName: data.companyName,
    taxId: data.taxId,
    address: data.address,
    tel: data.tel,
    fax: data.fax
});

const deleteCompany = (companyId) => HTTP.delete(END_POINT + "/" + companyId);

export {
    listCompany,
    isExistCompanyCode,
    insert,
    update,
    deleteCompany
}